"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_2 = require("react");

var react_autocomplete_1 = __importDefault(require("react-autocomplete"));

var react_web_components_1 = require("@nimles/react-web-components");

var styled_1 = __importDefault(require("@emotion/styled"));

var react_fontawesome_1 = require("@fortawesome/react-fontawesome");

var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");

var compare = function compare(property, descending) {
  return function (a, b) {
    var aProperty = a[property];
    var bProperty = b[property];

    if (typeof aProperty === 'number' && typeof bProperty === 'number') {
      return aProperty - bProperty;
    }

    if (aProperty < bProperty) {
      return descending ? 1 : -1;
    }

    if (aProperty > bProperty) {
      return descending ? -1 : 1;
    }

    return 0;
  };
};

var sortBy = function sortBy(array, property, descending) {
  return array.sort(compare(property, descending));
};

var InputContainer = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var ClearButton = styled_1.default.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: 20px;\n  right: 0;\n  background: transparent;\n  border: none;\n  outline: none;\n  padding-right: 10px;\n  color: grey;\n  cursor: pointer;\n"], ["\n  position: absolute;\n  top: 20px;\n  right: 0;\n  background: transparent;\n  border: none;\n  outline: none;\n  padding-right: 10px;\n  color: grey;\n  cursor: pointer;\n"])));

exports.FacetAutoComplete = function (_a) {
  var availableFacets = _a.availableFacets,
      selectedFacet = _a.selectedFacet,
      onSelect = _a.onSelect;

  var _b = react_2.useState(selectedFacet || ''),
      value = _b[0],
      setValue = _b[1];

  react_2.useEffect(function () {
    setValue(selectedFacet);
  }, [selectedFacet]);
  return react_1.default.createElement(react_autocomplete_1.default, {
    getItemValue: function getItemValue(item) {
      return String(item.value);
    },
    items: sortBy(availableFacets, 'value'),
    renderInput: function renderInput(props) {
      return react_1.default.createElement(InputContainer, null, react_1.default.createElement(react_web_components_1.Input, __assign({}, props)), react_1.default.createElement(ClearButton, {
        onClick: function onClick() {
          return onSelect(undefined);
        }
      }, react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, {
        icon: free_solid_svg_icons_1.faTimes
      })));
    },
    renderMenu: function renderMenu(items, value, style) {
      return react_1.default.createElement(react_web_components_1.Card, null, react_1.default.createElement(react_web_components_1.CardBody, {
        style: __assign({}, style),
        children: items
      }));
    },
    shouldItemRender: function shouldItemRender(item, value) {
      console.log('Item: ', item);
      return String(item.value).toLowerCase().indexOf(String(value).toLowerCase()) > -1;
    },
    renderItem: function renderItem(item, isHighlighted) {
      return react_1.default.createElement("div", {
        key: item.value,
        style: {
          background: isHighlighted ? 'lightgray' : 'white'
        }
      }, item.value);
    },
    value: value,
    onChange: function onChange(e) {
      return setValue(e.target.value);
    },
    onSelect: onSelect
  });
};

var templateObject_1, templateObject_2;